<app-header *ngIf="showHeader"></app-header>
<app-maintenance-scroller *ngIf="showHeader && store.showBannerMaintenance()"></app-maintenance-scroller>
<div class="m-body" id="m-body">
  <router-outlet></router-outlet>
</div>
<app-footer *ngIf="showFooter"></app-footer>
<app-snackbar></app-snackbar>
